import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getCTSDK } from 'services/ctClient'
import { Outlet } from 'react-router-dom'
import { useHasToken } from 'hooks/useHasToken'

const ctSDK = getCTSDK()

const PrivateRoute = () => {
    const navigate = useNavigate()

    useEffect(() => {
        const validateToken = async () => {
            try {
                await ctSDK.post('/users/validate')
            } catch (error) {
                console.error(error)
                navigate('/authLogin')
            }
        }

        validateToken()
    }, [navigate])

    // If no token, to prevent runtime errors with fetching we will
    // redirect to login page immediately
    const hasToken = useHasToken()
    if (!hasToken) {
        navigate('/authLogin')
        return null
    }

    return <Outlet />
}

export default PrivateRoute
